import React, { useState } from "react";
import PropTypes from "prop-types";
import CreatableSelect from "react-select/creatable";
import "./TagStyles.scss";

const TagView = ({
  className = "",
  isrequired = false,
  error,
  label,
  options,
  isSearchable,
  isClearable,
  classNamePrefix,
  onInputChange,
  onChange,
  value,
  inputValue,
  handleKeyDown,
  ...props
}) => {
  return (
    <div className="tag_wrapper">
      {label && (
        <span className={`tag__label text-muted`}>
          {label} {isrequired && <span /*className="text-danger"*/>*</span>}
        </span>
      )}
      <CreatableSelect
        classNamePrefix={classNamePrefix ? classNamePrefix : "tag"}
        value={value}
        inputValue={inputValue}
        options={options}
        isSearchable={isSearchable}
        className={`tag ${className} ${error ? "error" : ""} `}
        placeholder={""}
        isMulti
        components={{
          // DropdownIndicator: () => null,
          ClearIndicator: () => null,
          IndicatorSeparator: () => null,
          // Menu: () => null,
          // MultiValue: () => null,
          // MultiValueRemove: () => null,
        }}
        onKeyDown={handleKeyDown}
        onInputChange={onInputChange}
        onChange={onChange}
        {...props}
      />
      <div className={error ? `errorText` : "d-none"}>{error ? error : ""}</div>
    </div>
  );
};

TagView.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
  label: PropTypes.string,
  isSearchable: PropTypes.bool,
  isClearable: PropTypes.bool,
  options: PropTypes.array,
};

export default TagView;
